var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataCenter"},[_c('el-tabs',{staticClass:"education-content tabs-full",attrs:{"type":"card"},on:{"tab-click":_vm.init},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"得分榜单","name":"scoreList"}},[_c('DataCenterScoreList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }